import React from 'react'
import Datas from '../data/footer/footer2.json'
import { Link } from 'react-router-dom'
import { Container, Row, Col } from 'react-bootstrap'
import BackToTop from './common/BackToTop'
import { Styles } from './styles/footerTwo.js'

export default function FooterTwo() {
	return (
		<Styles>
			{/* Footer Two */}
			<footer
				className='footer2'
				style={{
					backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/${Datas.backgroundImage})`
				}}
			>
				<Container>
					<Row>
						<Col md='5'>
							<div className='footer-logo-info'>
								<img
									src={process.env.PUBLIC_URL + '/assets/images/f-logo.png'}
									alt=''
									className='img-fluid'
								/>
								<p>
									To provide a balanced curriculum that will produce
									intellectually sharp minds fortified with self-worth, ethical
									values and practical skills to enable them compete favourably
									in a rapidly changing global society.
								</p>
							</div>
						</Col>
						<Col md='4'>
							<div className='f-in-touch'>
								<h5>Get in Touch</h5>
								<ul className='list-unstyled'>
									<li>
										<i className='las la-map-marker'></i>Katikamu, 25 miles
										along Hoima Road
									</li>
									<li>
										<i className='las la-envelope'></i>
										<a href='mailto:info@licoka.ac.ug'>info@licoka.ac.ug</a>,
										&nbsp;
										<a href='mailto:kamukati25@gmail.com'>
											kamukati25@gmail.com
										</a>
									</li>
									<li>
										<i className='las la-phone'></i>
										<a href='tel:+256 752 470625'>
											{/* +256 414 254043 */}
											+256 752 470625
										</a>
										,&nbsp;
										<a href='tel:+256 772 470625'>
											{/* +256 392 888088 */}
											+256 772 470625
										</a>
									</li>
									<li>
										<i className='las la-mobile'></i>
										<a href='tel:+256 706 888002'>+256 706 888002</a>
									</li>
								</ul>
							</div>
						</Col>
						<Col md='3'>
							<div className='f-links'>
								<h5>Useful Links</h5>
								<ul className='list-unstyled'>
									<li>
										<Link to={process.env.PUBLIC_URL + '/about-us'}>
											<i className='las la-angle-right'></i>About Us
										</Link>
									</li>
									<li>
										<Link to={process.env.PUBLIC_URL + '/academics'}>
											<i className='las la-angle-right'></i>Academics
										</Link>
									</li>
									<li>
										<Link to={process.env.PUBLIC_URL + '/contact-us'}>
											<i className='las la-angle-right'></i>Contact Us
										</Link>
									</li>
									<li>
										<Link to={process.env.PUBLIC_URL + '/alumni'}>
											<i className='las la-angle-right'></i>Alumni
										</Link>
									</li>
									<li>
										<Link to={process.env.PUBLIC_URL + '/apply'}>
											<i className='las la-angle-right'></i>Apply Now
										</Link>
									</li>
								</ul>
							</div>
						</Col>
						<Col md='12'>
							<div className='copytext-area text-center'>
								<p>
									&copy; {new Date().getFullYear()} Light College Katikamu |
									Made with <i className='las la-heart'></i> by&nbsp;
									<a
										href='https://bytestream.tech'
										target='_blank'
										rel='noopener noreferrer'
									>
										Bytestream
									</a>
								</p>

								<ul className='social list-unstyled list-inline'>
									<li className='list-inline-item'>
										<a href='https://www.facebook.com/licoka256/'>
											<i className='fab fa-facebook-f'></i>
										</a>
									</li>
									<li className='list-inline-item'>
										<a href={process.env.PUBLIC_URL + '/'}>
											<i className='fab fa-twitter'></i>
										</a>
									</li>
									<li className='list-inline-item'>
										<a href={process.env.PUBLIC_URL + '/'}>
											<i className='fab fa-linkedin-in'></i>
										</a>
									</li>
									<li className='list-inline-item'>
										<a href={process.env.PUBLIC_URL + '/'}>
											<i className='fab fa-youtube'></i>
										</a>
									</li>
								</ul>
							</div>
						</Col>
					</Row>
				</Container>

				{/* Back To Top  */}
				<BackToTop />
			</footer>
		</Styles>
	)
}
